import {
  dateTimeFormatter,
  assetsFormatter,
  dniFormatter,
  toNumber,
} from 'formatters'

let movementType = {
  r: 'Transferencia recibida',
  s: 'Transferencia realizada',
  l: 'Liquidación',
  a: 'Acreditación',
  c: 'Acreditación BUS',
  u: 'Ajuste manual',
}

let operationType = {
  d: {
    prefix: '-',
    class: 'text-danger',
    label: 'Depósito',
  },
  c: {
    prefix: '',
    class: '',
    label: 'Credito',
  },
}

export const definitions = {
  id: {
    field: 'movementid',
    headerName: 'Id',
    width: 30,
    //renderCell: (params) => <GridProceedingStatus status={params.value} />,
  },
  date: {
    field: 'movementdate',
    headerName: 'Fecha',
    minWidth: 150,
    type: 'date',

    valueFormatter: (params) => {
      return dateTimeFormatter(params.value)
    },
    reportType: 'date',
  },
  ASL: {
    field: 'amount',
    headerName: 'ASL',
    width: 70,
    renderCell: (params) => {
      return (
        <span className={params?.row?.type === 'd' ? 'text-error' : ''}>
          {operationType[params?.row?.type]?.prefix +
            assetsFormatter(params.value, 'no currency')}
        </span>
      )
    },
    reportFormat: (row) => {
      return parseInt(
        operationType[row?.type]?.prefix +
        assetsFormatter(row?.amount, 'no currency')
      )
    },
  },
  statementASL: {
    field: 'amount',
    headerName: 'ASL',
    width: 70,
    renderCell: (params) => {
      if (params?.row?.movementtype === 'l' && params?.row?.state === 'c') {
        return 0
      }
      return (
        <span className={params?.row?.type === 'd' ? 'text-error' : ''}>
          {operationType[params?.row?.type]?.prefix +
            assetsFormatter(params.value, 'no currency')}
        </span>
      )
    },
    reportFormat: (row) => {
      if (row?.movementtype === 'l' && row?.state === 'c') {
        return 0
      }
      return operationType[row?.type]?.prefix + toNumber(row?.amount)
    },
  },
  comment: {
    field: 'comment',
    headerName: 'Descripcion',
    minWidth: 350,
    flex: 1,
    valueGetter: (params) => {
      if (params?.row?.movementtype === 'l' && params?.row?.state === 'c') {
        return `Solicitud de liquidación por ${assetsFormatter(
          params.row.amount
        )} no exitosa`
      }
      return params?.row?.comment
    },
    reportFormat: (row) => {
      if (row?.movementtype === 'l' && row?.state === 'c') {
        return `Solicitud de liquidación por ${assetsFormatter(
          row.amount
        )} no exitosa`
      }
      return row?.comment
    },
  },
  transferType: {
    field: 'movementtype',
    headerName: 'Tipo de movimiento',
    width: 160,
    valueGetter: (params) => {
      if (params?.row?.movementtype === 'a' || params?.row?.movementtype === 'c') {
        if (params?.row?.sender === 'Billetera San Luis BUS') return "Acreditación BUS"
        else return "Acreditación EST"
        // return params?.row?.comment
      } else return movementType[params.value]
    },
    reportFormat: (row) => {
      if (row?.movementtype === 'a' || row?.movementtype === 'c') {
        if (row?.sender === 'Billetera San Luis BUS') return "Acreditación BUS"
        else return "Acreditación EST"
      } else return movementType[row['movementtype']]
      // return row?.comment
    },
  },
  Beneficiary: {
    field: 'Beneficiary.userdni',
    headerName: 'Destinatario',
    width: 280,
    sortable: false,
    valueGetter: (params) => {
      if (params?.row?.['Beneficiary.userdni']) {
        return `${params.row['Beneficiary.firstname']} ${params.row['Beneficiary.lastname']
          } (${dniFormatter(params.row['Beneficiary.userdni'])})`
      }
      return `${params.row['Users.firstname']} ${params.row['Users.lastname']
        } (${dniFormatter(params.row['Users.userdni'])})`
    },
    reportFormat: (row) => {
      if (row?.['Beneficiary.userdni']) {
        return `${row['Beneficiary.firstname']} ${row['Beneficiary.lastname']
          } (${dniFormatter(row['Beneficiary.userdni'])})`
      }
      return `${row['Users.firstname']} ${row['Users.lastname']
        } (${dniFormatter(row['Users.userdni'])})`
    },
    reportType: 'string',
  },
  statementBeneficiary: {
    field: 'Beneficiary.userdni',
    headerName: 'Destinatario',
    width: 320,
    sortable: false,
    valueGetter: (params) => {
      if (params?.row?.['movementtype'] === 'u') {
        return ''
      }
      if (params?.row?.['movementtype'] === 'l') {
        return `CBU:${params.row['Transfer.cbu']} | CUIL:${params.row['Transfer.cuit']}`
      }
      if (params?.row?.['movementtype'] === 'r') {
        return `${params.row['Users.firstname']} ${params.row['Users.lastname']
          } (${dniFormatter(params.row['Users.userdni'])})`
      }
      if (params?.row?.['Beneficiary.userdni']) {
        return `${params.row['Beneficiary.firstname']} ${params.row['Beneficiary.lastname']
          } (${dniFormatter(params.row['Beneficiary.userdni'])})`
      }
      return `${params.row['Users.firstname']} ${params.row['Users.lastname']
        } (${dniFormatter(params.row['Users.userdni'])})`
    },
    reportFormat: (row) => {
      if (row?.['movementtype'] === 'u') {
        return ''
      }
      if (row?.['movementtype'] === 'l') {
        return `CBU:${row['Transfer.cbu']} | CUIL:${row['Transfer.cuit']}`
      }
      if (row?.['movementtype'] === 'r') {
        return `${row['Users.firstname']} ${row['Users.lastname']
          } (${dniFormatter(row['Users.userdni'])})`
      }
      if (row?.['Beneficiary.userdni']) {
        return `${row['Beneficiary.firstname']} ${row['Beneficiary.lastname']
          } (${dniFormatter(row['Beneficiary.userdni'])})`
      }
      return `${row['Users.firstname']} ${row['Users.lastname']
        } (${dniFormatter(row['Users.userdni'])})`
    },
    reportType: 'string',
  },
  remitent: {
    field: 'Users.userdni',
    headerName: 'Emisor',
    width: 280,
    sortable: false,
    valueGetter: (params) => {
      if (params?.row?.['movementtype'] === 'u') {
        return ''
      }
      if (params?.row?.['movementtype'] === 'r') {
        return `${params.row['Users.firstname']} ${params.row['Users.lastname']
          } (${dniFormatter(params.row['Users.userdni'])})`
      }
      if (params?.row?.['Beneficiary.userdni']) {
        return `${params.row['Users.firstname']} ${params.row['Users.lastname']
          } (${dniFormatter(params.row['Users.userdni'])})`
      }
      if (['a', 'c'].includes(params?.row?.['movementtype'])) {
        return `Activos San Luis`
      }
      return ``
    },
    reportFormat: (row) => {
      if (row?.['movementtype'] === 'u') {
        return ''
      }
      if (row?.['movementtype'] === 'r') {
        return `${row['Users.firstname']} ${row['Users.lastname']
          } (${dniFormatter(row['Users.userdni'])})`
      }
      if (row?.['Beneficiary.userdni']) {
        return `${row['Users.firstname']} ${row['Users.lastname']
          } (${dniFormatter(row['Users.userdni'])})`
      }
      if (['a', 'c'].includes(row?.['movementtype'])) {
        return `Activos San Luis`
      }
      return ``
    },
  },
  statementRemitent: {
    field: 'Users.userdni',
    headerName: 'Emisor',
    width: 280,
    sortable: false,
    valueGetter: (params) => {
      if (params?.row?.['movementtype'] === 'u') {
        return ''
      }
      if (params?.row?.['movementtype'] === 'r') {
        return `${params?.row['Beneficiary.firstname']} ${params?.row['Beneficiary.lastname']
          } (${dniFormatter(params?.row['Beneficiary.userdni'])})`
      }
      if (
        params?.row?.['Beneficiary.userdni'] ||
        params?.row?.['movementtype'] === 'l'
      ) {
        return `${params.row['Users.firstname']} ${params.row['Users.lastname']
          } (${dniFormatter(params.row['Users.userdni'])})`
      }
      if (['a', 'c'].includes(params?.row?.['movementtype'])) {
        return `Activos San Luis`
      }
      return ``
    },
    reportFormat: (row) => {
      if (row?.['movementtype'] === 'u') {
        return ''
      }
      if (row?.['movementtype'] === 'r') {
        return `${row['Beneficiary.firstname']} ${row['Beneficiary.lastname']
          } (${dniFormatter(row['Beneficiary.userdni'])})`
      }
      if (row?.['Beneficiary.userdni']) {
        return `${row['Users.firstname']} ${row['Users.lastname']
          } (${dniFormatter(row['Users.userdni'])})`
      }
      if (['a', 'c'].includes(row?.['movementtype'])) {
        return `Activos San Luis`
      }
      return ``
    },
  },
  cbu: {
    field: 'Transfer.cbu',
    headerName: 'CBU',
    sortable: false,
    width: 200,
  },
  cuil: {
    field: 'Transfer.cuit',
    headerName: 'CUIL',
    sortable: false,
    width: 200,
  },
  amount: {
    field: 'Transfer.amount',
    headerName: 'ARS',
    width: 80,
    sortable: false,
    valueGetter: (params) => {
      if (params?.row?.movementtype === 'l' && params?.row?.state === 'c') {
        return ''
      }
      return params.value
    },
    reportFormat: (row) => {
      return row['Transfer.amount'] || ''
    },
  },
  accountName: {
    field: 'Users.firstname',
    headerName: 'Titular',
    width: 200,
    sortable: false,
    valueGetter: (params) => {
      return `${params.row['Users.firstname']} ${params.row['Users.lastname']}`
    },
    reportFormat: (row) => {
      return `${row['Users.firstname']} ${row['Users.lastname']}`
    },
  },
  DNI: {
    field: 'Users.userdni',
    headerName: 'DNI',
    width: 90,
    sortable: false,
    valueGetter: (params) => {
      return `${dniFormatter(params.row['Users.userdni'])}`
    },
  },
  studentDNI: {
    field: 'studentdni',
    headerName: 'DNI',
    width: 90,
    sortable: false,
    valueGetter: (params) => {
      return `${dniFormatter(params.row['studentdni'])}`
    },
  },
  fullName: {
    field: 'firstname',
    headerName: 'Nombre y apellido',
    width: 200,
    sortable: false,
    valueGetter: (params) => {
      return `${params.row['firstname']} ${params.row['lastname']}`
    },
    reportFormat: (row) => {
      return `${row['firstname']} ${row['lastname']}`
    },
  },
  schoolcycle: {
    field: 'schoolcycle',
    headerName: 'Ciclo lectivo',
    width: 100,
    sortable: false,
  },
  liquidated: {
    field: 'liquidated',
    headerName: 'Activos liquidados',
    minWidth: 100,
    flex: 1,
    sortable: false,
    valueFormatter: (params) => toNumber(params.value) * -1,
    reportFormat: (row) => toNumber(row?.['liquidated']) * -1,
  },
  adjusted: {
    headerName: 'Ajustes manuales',
    field: 'adjustmentCredit',
    minWidth: 100,
    flex: 1,
    sortable: false,
    valueGetter: (params) => {
      let adjustmentCredit = params?.row['adjustmentCredit']
        ? toNumber(params.row['adjustmentCredit'])
        : 0
      let adjustmentDebit = params?.row['adjustmentDebit']
        ? toNumber(params.row['adjustmentDebit'])
        : 0
      let total = adjustmentCredit - adjustmentDebit
      return total
    },
    reportFormat: (row) => {
      let adjustmentCredit = row['adjustmentCredit']
        ? toNumber(row['adjustmentCredit'])
        : 0
      let adjustmentDebit = row['adjustmentDebit']
        ? toNumber(row['adjustmentDebit'])
        : 0
      let total = adjustmentCredit - adjustmentDebit
      return total
    },
  },
  pendingLiquidated: {
    field: 'pendingLiquidated',
    headerName: 'Liquidaciones en proceso',
    minWidth: 100,
    flex: 1,
    sortable: false,
    valueFormatter: (params) => toNumber(params.value) * -1,
    reportFormat: (row) => toNumber(row['pendingLiquidated']) * -1,
  },
  sent: {
    field: 'sent',
    headerName: 'Transferencias realizadas',
    minWidth: 100,
    flex: 1,
    sortable: false,
    valueFormatter: (params) => toNumber(params.value) * -1,
    reportFormat: (row) => toNumber(row?.['sent']) * -1,
  },
  received: {
    field: 'received',
    headerName: 'Transferencias recibidas',
    minWidth: 100,
    flex: 1,
    sortable: false,
    valueFormatter: (params) => toNumber(params.value),
    reportFormat: (row) => toNumber(row['received']),
  },
  accredited: {
    field: 'accredited',
    headerName: 'Activos acreditados',
    minWidth: 100,
    flex: 1,
    sortable: false,
    valueFormatter: (params) => toNumber(params.value),
    reportFormat: (row) => toNumber(row['accredited']),
  },
  endingBalance: {
    field: 'studentid',
    headerName: 'Saldo ASL',
    minWidth: 100,
    flex: 1,
    sortable: false,
    valueGetter: (params) => {
      let liquidated = params.row['liquidated']
        ? toNumber(params.row['liquidated'])
        : 0
      let sent = params.row['sent'] ? toNumber(params.row['sent']) : 0
      let received = params.row['received']
        ? toNumber(params.row['received'])
        : 0
      let accredited = params.row['accredited']
        ? toNumber(params.row['accredited'])
        : 0
      let liquidatedPending = params.row['liquidatedPending']
        ? toNumber(params.row['liquidatedPending'])
        : 0
      let adjustmentCredit = params.row['adjustmentCredit']
        ? toNumber(params.row['adjustmentCredit'])
        : 0
      let adjustmentDebit = params.row['adjustmentDebit']
        ? toNumber(params.row['adjustmentDebit'])
        : 0
      let total =
        accredited -
        liquidated -
        liquidatedPending +
        received -
        sent -
        adjustmentDebit +
        adjustmentCredit
      return total
    },
    reportFormat: (row) => {
      let liquidated = row['liquidated'] ? toNumber(row['liquidated']) : 0
      let sent = row['sent'] ? toNumber(row['sent']) : 0
      let received = row['received'] ? toNumber(row['received']) : 0
      let accredited = row['accredited'] ? toNumber(row['accredited']) : 0
      let liquidatedPending = row['liquidatedPending']
        ? toNumber(row['liquidatedPending'])
        : 0
      let adjustmentCredit = row['adjustmentCredit']
        ? toNumber(row['adjustmentCredit'])
        : 0
      let adjustmentDebit = row['adjustmentDebit']
        ? toNumber(row['adjustmentDebit'])
        : 0
      let total =
        accredited -
        liquidated -
        liquidatedPending +
        received -
        sent -
        adjustmentDebit +
        adjustmentCredit
      return total
    },
  },
  generalReportYear: {
    field: 'cycle',
    headerName: 'Año',
    minWidth: 130,
    width: 130,
    sortable: false,
    reportSum: 'Total',
  },
  totalAcredited: {
    field: 'acreditation',
    headerName: 'Total de activos acreditados',
    minWidth: 100,
    width: 100,
    flex: 1,
    sortable: false,
    reportSum: true,
  },
  totalLiquidated: {
    field: 'liquidation',
    headerName: 'Total de activos liquidados',
    minWidth: 100,
    width: 100,
    flex: 1,
    sortable: false,
    reportSum: true,
  },
  totalBalance: {
    field: 'total',
    headerName: 'Balance de activos',
    minWidth: 100,
    width: 100,
    flex: 1,
    sortable: false,
    reportSum: true,
  },
  movementState: {
    field: 'state',
    headerName: 'Estado',
    width: 90,
    sortable: false,
    renderCell: (params) => {
      if (params.value === 'p') {
        return <span className="text-error">En proceso</span>
      }
      if (params.value === 'c') {
        return <span className="text-error">Cancelada</span>
      }
      if (params.value === 's') {
        return <span className="text-success">Completada</span>
      }
    },
    reportFormat: (row) => {
      if (row['state'] === 'p') {
        return 'En proceso'
      }
      if (row['state'] === 'c') {
        return 'Cancelada'
      }
      if (row['state'] === 's') {
        return 'Completada'
      }
    },
  },
}

export const generalASLReportColumns = [
  definitions.generalReportYear,
  definitions.totalAcredited,
  definitions.totalLiquidated,
  definitions.totalBalance,
]

export const transferColumnDefinition = [
  definitions.id,
  definitions.date,
  definitions.transferType,
  definitions.movementState,
  definitions.statementASL,
  definitions.comment,
  definitions.Beneficiary,
  definitions.remitent,
]
export const statementColumnDefinition = [
  definitions.id,
  definitions.date,
  definitions.transferType,
  definitions.movementState,
  definitions.statementASL,
  definitions.amount,
  definitions.comment,
  definitions.statementBeneficiary,
  definitions.statementRemitent,
]

export const bankTransferColumnDefinition = [
  definitions.date,
  definitions.statementASL,
  definitions.amount,
  definitions.movementState,
  definitions.cbu,
  definitions.cuil,
  definitions.accountName,
  definitions.DNI,
]
export const balanceColumnDefinition = [
  definitions.schoolcycle,
  definitions.fullName,
  definitions.studentDNI,
  definitions.accredited,
  definitions.received,
  definitions.sent,
  definitions.adjusted,
  definitions.liquidated,
  definitions.pendingLiquidated,
  definitions.endingBalance,
]
export const availableASLDefinition = [
  definitions.fullName,
  definitions.studentDNI,
  definitions.endingBalance,
]
